var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-tabs',{staticStyle:{"margin-bottom":"20px"},attrs:{"type":"border-card"},on:{"tab-click":_vm.clickTab},model:{value:(_vm.activeTab),callback:function ($$v) {_vm.activeTab=$$v},expression:"activeTab"}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }